/**
 * Default values used as fallbacks when API data is unavailable
 * These values are used for initial state before data is fetched
 */

const defaults = {
  // Default pricing data - Updated January 2026
  // Source: https://www.iledefrance-mobilites.fr (scraped live)
  // Note: Fare reform in 2025 replaced t+ tickets with new Metro-Train-RER and Bus-Tram tickets
  pricing: {
    // Single tickets (loaded on Navigo Easy or smartphone)
    singleTicket: '2.55',           // Metro-Train-RER single ticket (full price)
    singleTicketReduced: '1.30',    // Metro-Train-RER reduced price
    busTramTicket: '2.05',          // Bus-Tram single ticket (full price)
    busTramTicketReduced: '1.05',   // Bus-Tram reduced price
    // Navigo Liberté+ (pay-as-you-go, charged to bank account)
    navigoLibertePlus: '2.04',      // Metro/Train/RER per trip
    navigoLiberteBus: '1.64',       // Bus/Tram per trip
    dailyCap: '14.00',              // Max daily charge (excl. airports)
    // Cards
    navigoEasyCard: '2.00',         // Card cost (reloadable)
    navigoDecouverte: '5.00',       // Card cost + weekly/monthly pass
    // Navigo Découverte passes (zones 1-5)
    weeklyPass: '30.75',            // Mon-Sun weekly pass
    monthlyPass: '86.40',           // Calendar-month pass
    // Note: Carnets (10-ticket packs) were discontinued in the 2025 reform
    carnet10Tickets: 'Discontinued',
    lastUpdated: 'January 2026',
    confidence: 'High',
  },

  // UI placeholders
  placeholders: {
    chatInput: 'e.g., How do I buy a Navigo Easy card?',
    chatEmpty: 'e.g. What should I ask the person at the helpdesk if I want to go to the Louvre museum?',
  },

  // Tab labels
  tabs: {
    paymentMethods: 'Payment Methods',
    emergencyHelp: 'Emergency Help',
    troubleshooting: 'Troubleshooting',
    transitAssistant: 'AI Transit Assistant',
  },
};

export default defaults;
